// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inviteTitle_root__AOXiT {\n  align-items: center;\n  margin-top: 30px;\n  border-bottom: 1px solid #eef2f4;\n  display: grid;\n  grid-template-columns: 3fr 1fr 2fr 1fr 100px; }\n  .inviteTitle_root__AOXiT .inviteTitle_headerIteam__WQC9G {\n    -webkit-user-select: none;\n            user-select: none;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 18px;\n    color: #464646; }\n", ""]);
// Exports
exports.locals = {
	"root": "inviteTitle_root__AOXiT",
	"headerIteam": "inviteTitle_headerIteam__WQC9G"
};
module.exports = exports;
